import styled from '@emotion/styled'

import EnergyDisabledIcon from '@/assets/icons/energy-disabled.svg?react'
import { BRAND_COLOR } from '@/constants/colors'

const BORDER_COLOR_ACTIVE = '#ffdb39'
const BORDER_COLOR_DISABLED = '#5d5f65'
const TEXT_COLOR = '#454545'
const DISABLED_ICON_COLOR = '#D4D5D8'

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isDisabled',
})<{ isDisabled?: boolean }>`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px 8px 12px;
  background-color: white;
  border: 2px solid ${({ isDisabled }) => (isDisabled ? BORDER_COLOR_DISABLED : BORDER_COLOR_ACTIVE)};
  border-radius: 999px;
  box-shadow: ${({ isDisabled }) =>
    isDisabled
      ? '0px 2px 24px 0px rgba(0, 0, 0, 0.24)'
      : '0 0 40px 0 rgba(67, 63, 44, 0.08), 0 2px 16px 0 rgba(255, 219, 57, 0.4)'};
`

export const EnergyIcon = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`

export const DisabledIcon = styled(EnergyDisabledIcon)`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: ${DISABLED_ICON_COLOR};
`

export const LabelText = styled.span`
  font-size: 17px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.17px;
  color: ${TEXT_COLOR};
`

export const CountText = styled.span`
  font-size: 17px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.17px;
  color: ${BRAND_COLOR};
`
